import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CopyRow, highlightCopies } from './copyfinder';

/*
  The results table shared by Resource Test and Package Test: one row per copy, grouped by resource,
  so the columns line up down the page. Only wrong copies show unless "Show matching copies" is on.
  Each row opens the holder's JSON beneath it, folded down to that copy's value.
*/

interface ShownRow {
  row: CopyRow;
  firstOfResource: boolean;     //the resource's name and value are shown on its first row only
  key: string;
}

@Component({
  selector: 'app-copy-results',
  templateUrl: './copyresults.component.html',
  styleUrls: ['./resourcetest.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CopyResultsComponent implements OnChanges {
  @Input() rows: CopyRow[] = [];
  @Input() resourceCount: number = 0;
  @Input() holderCount: number = 0;
  @Input() holderLabel: string = '';

  showMatching: boolean = false;
  shown: ShownRow[] = [];
  wrongCount: number = 0;
  wrongResourceCount: number = 0;

  //Rows whose JSON is open, and the highlights for each, built when first opened
  opened = new Map<string, { notes: Map<string, string>, good: Set<string>, expand: Set<string> }>();

  ngOnChanges(): void {
    const wrong = this.rows.filter(r => !r.copy.correct);
    this.wrongCount = wrong.length;
    this.wrongResourceCount = new Set(wrong.map(r => r.resource.resourceId)).size;
    this.opened.clear();
    this.build();
  }

  build() {
    const visible = this.showMatching ? this.rows : this.rows.filter(r => !r.copy.correct);

    this.shown = visible.map((row, i) => ({
      row,
      firstOfResource: i == 0 || visible[i - 1].resource.resourceId != row.resource.resourceId,
      key: row.resource.resourceId + '|' + row.holder.kind + '|' + row.holder.name + '|' + row.copy.valuePath
    }));
  }

  toggle(s: ShownRow) {
    if (this.opened.has(s.key))
      this.opened.delete(s.key);
    else
      this.opened.set(s.key, highlightCopies([s.row.copy], s.row.resource));
  }

  trackKey(index: number, s: ShownRow) {
    return s.key;
  }
}
